// removed by extract-text-webpack-plugin
module.exports = {"formTitle":"_1aHYZbuy1te_D9mKF1XROg","saveButton":"_2nxu4f-aKYHjF_NLLoWirv","cancelButton":"_7uCfYJ0p2t810Zh2pd1HF","sliderTitle":"_3PJYW6cxgF-ot8g5_Jkh0","sliderValLeft":"_390RYqZMpnVrlIKKxJ4vDO","sliderValRight":"_3CbqVzktLqXGu8Dz72BpKY","sliderFootLeft":"_3XByFmWUs14G0WCjpOnjka","sliderFootRight":"_2hqCX78Zmd5IEuEWl7HQwu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/Step3.css
// module id = 1041
// module chunks = 0